import { getUserID } from "../Utility/service";
import { SERVICE_GET_ALL, SERVICE_ADD_ENDPOINTS, SERVICE_GET_ALL_EXISTING_ENDPOINTS, SERVICE_DELETE_API_BY_ID, GET_SERVICE } from "../constants/Api_constants";
import { axiosSecureInstance } from "./axios";
const userId = getUserID();

export const getAllServices = async() => {
    try {
        const data = await axiosSecureInstance.get(SERVICE_GET_ALL);
        return data;
    } catch (error) {
        return error;
    }
}

export const getService = async(service_id) => {
    try {
        
        const data = await axiosSecureInstance.get(`api/integration/service/${service_id}`);
        return data;
    } catch (error) {
        return error;
    }
}

export const deleteService = async(service_id) => {
    try {
        
        const data = await axiosSecureInstance.delete(`api/integration/service/${service_id}`);
        return data;
    } catch (error) {
        return error;
    }
}

export const initOauth = async(service_id, authFields, authenticateFields, oauthurl,tokenurl, baseurl, type, contentType) => {
    try {
        
        const body = {
            service_id,
            userId,
            authFields,
            authenticateFields,
            oauthurl,
            tokenurl,
            baseurl,
            type,
            contentType
        }
        
        
        const data = await axiosSecureInstance.post(`api/integration/service/oauth/connect`,body);
        return data;
       
    } catch (error) {
        return error;
    }
}

export const addApiEndpoint = async(payload) => {
    try {
        const data = await axiosSecureInstance.post(SERVICE_ADD_ENDPOINTS, payload);
        return data;
    } catch (error) {
        return error;
    }
}

export const getExistingApis = async(service_id) => {
    try {
        const data = await axiosSecureInstance.post(SERVICE_GET_ALL_EXISTING_ENDPOINTS, {service_id});
        return data;
    } catch (error) {
        return error;
    }

}

export const deleteApiEndpoint = async(api_id) => {
    try {
        const data = await axiosSecureInstance.delete(`${SERVICE_DELETE_API_BY_ID}/${api_id}`);
        return data;
    } catch (error) {
        return error;
    }
}